import { trackEvent } from "analytics/posthog";

/**
 * "Started booking" for a booking that now exists (1NOW-11119): PostHog's funnel step, and Meta's
 * InitiateCheckout with eventID `ic-<booking id>`, which the server's InitiateCheckout repeats so
 * the two dedupe.
 *
 * Fired when the checkout page opens for a card booking, and when a Pay later booking is created,
 * since that path never opens the checkout page. Pay later does not send Purchase: that stays for
 * a payment that was actually taken.
 *
 * The value is the rental price without the security deposit, which is refunded and must not
 * inflate what the ad platforms optimise on.
 */
export const trackBookingStarted = (booking: any, car: any, currency?: string): void =>
  trackEvent("booking_started", {
    vehicle_id: car?.id,
    booking_id: booking?.id,
    value: booking?.final_price_without_security,
    currency,
  });
